module.exports = __webpack_public_path__ + "img/ordenes_a.fc124fa5.png";